import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../store';
import { AuthUserData } from '../models/user';

const useGetUserData = (options?: { skip?: boolean }): AuthUserData | null => {
  const { business_id: businessId } = useParams();
  // Hooks must run unconditionally: `skip` can flip between renders (e.g. it
  // depends on async-loaded data), and an early return before useSelector
  // shifts React's hook list, crashing the whole page.
  const { user: userData } = useSelector(
    (state: RootState) => state.auth,
  );
  if (options?.skip) {
    return null;
  }
  if (!businessId) {
    throw new Error('no business_id');
  }
  return userData;
};

export default useGetUserData;
